import React, { useEffect } from 'react'
import Header from '../Components/Header'
import { Avatar, Box, Container, Icon, IconButton, Typography } from '@mui/material'
import demo from "../Files/demo.svg"
import support from "../Files/support.svg"
import renseignement from "../Files/renseignement.svg"
import image from "../Files/Titles/vintage-pink-telephone-composition.jpg"
import Footer from '../Components/Footer'
import illustation from "../illustration.png"
import photo from "../PXL_20231009_125631885.jpg"
import Project from '../Components/Project'
import { LinkedIn, GitHub, Instagram, Facebook, Mail, Description, FormatQuote } from '@mui/icons-material'
import cover from "../cover1.jpg";
import cover1 from "../1.jpg";
import cover2 from "../2.jpg";
import cover3 from "../3.jpg";
import cover4 from "../4.jpg";
import { useTranslation } from 'react-i18next'
import SocialLink from '../Components/SocialLink'
import Formations from "../Data/Formations.json";
import Contacts from '../Components/Contact'
import { Carousel } from 'antd'
import TopHeader from '../Components/TopHeader'
import TitrePage from './TitrePage'
import { motion, Variants } from 'framer-motion'
import { title } from 'process'
import TitrePartie from '../Components/TitrePartie'

interface Props { }

function Contact(props: Props) {
    const { } = props
    const { t, i18n } = useTranslation();
    const scroll: Variants = {
        offscreen: {
            y: 15,
            opacity: .5
        },
        onscreen: {
            y: 10,
            opacity: 1,
            transition: {
                bounce: 0.6,
                duration: 1
            }
        }
    };

    const Motifs: Array<any> = [
        {
            image: demo,
            link: "/contact",
            title: "Demander une démo|Request a demo",
            provider: "Découvrez le pouvoir de nos solutions. Demandez une démo dès aujourd'hui.|Discover the power of our solutions. Request a demo today."

        },
        {
            image: support,
            link: "/contact",
            title: "Support client|Customer support",
            provider: "Nous sommes disponibles 24 heures sur 24 et 7 jours sur 7 pour répondre à vos questions et préoccupations. Appelez-nous|We're available 24 hours a day, 7 days a week to answer your questions and address your concerns. Call us at"

        },
        {
            image: renseignement,
            link: "/contact",
            title: "Demande de renseignements|Information request",
            provider: "Vous cherchez la bonne solution pour vos besoins en technologie bancaire ? Laissez notre équipe de vente vous guider.|Looking for the right solution for your banking technology needs? Let our sales team guide you."

        }
    ]
    return (
        <div style={{ backgroundColor: "inherit" }} >
            <TopHeader />
            <Header /><br />
            <TitrePage image={image} titre={'titrePage.contact.titre'} lien='contact' pageDescription={'titrePage.contact.description'} keyWords={'titrePage.contact.keywords'} />
            <Box>
                <Container>
                    <br />

                    <br /><br />
                    {/* <br /><br />
                    <center><SocialLink /></center> */}
                    <center><TitrePartie titre={t("Contact.texte1")} /></center>
                    <br />
                    <Box display={{ xs: "block", md: "flex" }}>
                        {Motifs.map((f, index) => (
                            <Project buttonName={t("contactUs")} showBtn logo={f.image} link={f.link} linkName={f.title} date={""} title={f.title.split("|")[i18n.language == "fr" ? 0 : 1]} description={f.provider.split("|")[i18n.language == "fr" ? 0 : 1]} />
                        ))}
                    </Box>
                    <br />

                    <TitrePartie titre={t("Contact.texte2")} /> <br />
                    <Typography fontWeight={"lighter"} textAlign={"left"}>{t("Contact.texte3")}</Typography>
                    {/* <motion.div
                        initial="offscreen"
                        whileInView="onscreen"
                        viewport={{ once: false, amount: 0.8 }}
                        variants={scroll}
                    >
                        <label style={{marginLeft: "0%"}} htmlFor="">{t("Texte.Accueil.Partie9.sousTitre")}</label>
                    </motion.div> */}
                    <br />
                    <Contacts />
                </Container>
                <br /><br />
            </Box>
            <Footer />
        </div>
    )
}

export default Contact